<!-- 右侧展示区 -->
<template>
  <div class='display-area'>
    <header class='uk-flex uk-flex-between'>
      <h1>{{ $t('integration.monitoring_point_monitoring') }}</h1>
      <div>
        <i class='el-icon-copy-document' :title="$t('integration.pop-up_notification')" @click='openWin'></i>
        <i class='el-icon-refresh' :title="$t('public.reflash')" @click='reflashPoint'></i>
        <i class='iconfont icon-baocun' :title="$t('public.save')" @click='savePoint'></i>
      </div>
    </header>
    <div style='height:calc(100% - 45px);'>
      <RealTimeSituation ref='realTimeSituation'></RealTimeSituation>
    </div>

    <!-- 详情框 只能放外面 放里面进行循环造成不必要的实例创建 -->
    <sensorDetailDialog :show.sync='sensorDetailShow'></sensorDetailDialog>
    <gatewayDetailDialog :show.sync='gatewayDetailShow'></gatewayDetailDialog>
    <displayDetailDialog :show.sync='displayDetailShow'></displayDetailDialog>
    <relayDetailDialog :show.sync='relayDetailShow'></relayDetailDialog>
    <ProbeDetail></ProbeDetail>
  </div>
</template>

<script>
import RealTimeSituation from './RealTimeSituation.vue'
import { goNewWindows } from '@/utils/goNewWin'
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog.vue'
import ProbeDetail from '@/components/dialog/probeDetail/ProbeDetail.vue'

export default {
  data () {
    return {
      sensorDetailShow: false,
      gatewayDetailShow: false,
      displayDetailShow: false,
      relayDetailShow: false
    }
  },
  components: {
    RealTimeSituation,
    sensorDetailDialog,
    gatewayDetailDialog,
    displayDetailDialog,
    relayDetailDialog,
    ProbeDetail
  },
  methods: {
    // 弹窗展示监测点
    openWin () {
      const carrierList = this.$refs.realTimeSituation.carrierList
      // 按照需求 不保存后 弹出的监测点 也需要保持一致
      goNewWindows(
        {
          path: '/monitorPointRealTime',
          way: '_blank',
          query: {
            ids: carrierList.map(item => item.carrier.id).join(',')
          }
        },
        true
      )
    },
    // 刷新监测点 调用子组件上的方法
    reflashPoint () {
      this.$refs.realTimeSituation.refreshPoint()
    },
    // 保存监测点
    savePoint () {
      this.$refs.realTimeSituation.savePoint()
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang='scss'>
.display-area {
  flex: 1;
  margin-left: 15px;

  header {
    height: 29px;
    border-bottom: 1px solid #cccccc;
    margin-bottom: 15px;

    h1 {
      font-size: 16px;
    }

    i {
      margin-right: 5px;
      cursor: pointer;
    }
  }
}
</style>
